<template>
  <v-navigation-drawer :touchless="true" permanent rail expand-on-hover>
<!--    <v-list-item-->
<!--        prepend-avatar="https://randomuser.me/api/portraits/men/85.jpg"-->
<!--        :to="{name: 'Dashboard'}"-->
<!--        nav>-->
<!--      <template #title>-->
<!--        <div>{{ sessionStore.profile.name }}</div>-->
<!--      </template>-->
<!--      <template #subtitle>-->
<!--        <div>{{ sessionStore.profile.email }}</div>-->
<!--      </template>-->
<!--      <template v-slot:append>-->
<!--        <v-btn-->
<!--            variant="text"-->
<!--            icon="mdi-cog"-->
<!--            :to="{name: 'Profile'}"-->
<!--        ></v-btn>-->
<!--      </template>-->
<!--    </v-list-item>-->

<!--    <v-divider></v-divider>-->

    <v-list density="compact" nav>
      <v-list-item prepend-icon="mdi-remote" title="장치" :to="{name: 'Devices'}"></v-list-item>
      <v-list-item prepend-icon="mdi-history" title="운영 기록" :to="{name: 'Logs'}"></v-list-item>
      <template v-if="sessionStore.profile.admin">
        <v-list-item prepend-icon="mdi-account-multiple-outline" title="가맹점" :to="{name: 'Partners'}"></v-list-item>
        <v-list-item prepend-icon="mdi-remote-tv" title="리모콘" :to="{name: 'Remocons'}"></v-list-item>
<!--        <v-list-item prepend-icon="mdi-note-outline" title="메모" :to="{name: 'Posts'}"></v-list-item>-->
        <v-list-item prepend-icon="mdi-cog-outline" title="설정" :to="{name: 'Settings'}"></v-list-item>
      </template>
    </v-list>

    <v-divider></v-divider>
    <v-list density="compact" nav>
      <v-list-item
          prepend-icon="mdi-logout"
          title="로그아웃"
          @click="onLogout"
      ></v-list-item>
    </v-list>
  </v-navigation-drawer>

  <v-main>
    <router-view :key="route.fullPath"></router-view>
  </v-main>
</template>

<script setup>
import {onMounted, onUnmounted} from "vue";
import {inject, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useAppStore} from "@/stores/app";
import {useSessionStore} from "@/stores/session";
import {HttpStatusCode} from "axios";

const drawer = ref(true);
const rail = ref(false);

const axios = inject('axios');
const network = inject('network');
const route = useRoute();
const router = useRouter();
const sessionStore = useSessionStore();
const appStore = useAppStore();

const onLogout = () => {
  if (!confirm('로그아웃 하시겠습니까?')) return;

  (async () => {
    const response = await axios.get('/api/auth/logout');
    await new Promise(r => network.useResponseChain()
        .use((response, next) => {
          if (!response || HttpStatusCode.Ok !== response.status || 0 !== response.data.code)
            return next && next();
          r();
        })
        .use(() => r())
        .run(response)
    );

    appStore.clear();
    sessionStore.authorized = false;
    await router.push({name: 'Login'});
  })();
};

onMounted(() => {
  appStore.connect();
});

onUnmounted(() => {
  appStore.disconnect();
});

</script>

<style lang="scss" scoped>

</style>
